import { AppRouteProps } from "@harea/component";
import React from "react";

const SettingsContainer = React.lazy(() => import('./containers/UserOrganisationDetailsParameters'))

export const SettingsRoutes: Array<AppRouteProps> = [
    {
        path: 'settings',
        title: "Generic.UserOrganisation.About.title",
        element: <SettingsContainer />,
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    }
]